import type { MediaItem } from '../types';

/**
 * Smart trim (server/src/services/video-trim.service.ts): a video plays only
 * its kept parts, jumping over black and frozen-and-silent stretches. These
 * helpers translate between the file's own time and "film time" (kept parts only).
 */

type Trim = NonNullable<MediaItem['trim']>;

/** Seconds of kept footage played when the file is at `t`. */
export function keptBefore(trim: Trim, t: number): number {
  let n = 0;
  for (const [s, e] of trim.segments) {
    if (t <= s) break;
    n += Math.min(t, e) - s;
  }
  return n;
}

/**
 * Where the file should be at `t`: unchanged inside a kept part, the start of
 * the next part when at (or past) the end of one or inside a cut, or null
 * when the last part is done.
 */
export function nextPosition(trim: Trim, t: number, epsilon = 0.04): number | null {
  for (const [s, e] of trim.segments) {
    if (t < s - epsilon) return s;
    if (t < e - epsilon) return t;
  }
  return null;
}
